const SCALE = BigInt("1000000000000000000");

export function aevoUnits(value: string): bigint {
  if (!/^\d+(\.\d{1,18})?$/.test(value))
    throw new Error("Enter an AEVO budget with at most 18 decimal places.");
  const [whole, fraction = ""] = value.split(".");
  return BigInt(whole) * SCALE + BigInt(fraction.padEnd(18, "0"));
}
export function formatAEVO(units: string): string {
  if (!/^\d+$/.test(units)) return "Unavailable";
  const value = BigInt(units);
  const fraction = (value % SCALE)
    .toString()
    .padStart(18, "0")
    .replace(/0+$/, "");
  return `${value / SCALE}${fraction ? `.${fraction}` : ""}`;
}
export function splitBudget(total: string, percent: string) {
  if (!/^\d+(\.\d{1,2})?$/.test(percent))
    throw new Error(
      "Maker share must be a percentage with at most two decimal places."
    );
  const [whole, fraction = ""] = percent.split(".");
  const share = BigInt(whole) * BigInt(100) + BigInt(fraction.padEnd(2, "0"));
  if (share > BigInt(10000))
    throw new Error("Maker share must be between 0 and 100%.");
  const pool = aevoUnits(total);
  if (pool <= BigInt(0))
    throw new Error("Total weekly budget must be greater than zero.");
  const maker = (pool * share) / BigInt(10000);
  return {
    pool_units: pool.toString(),
    allocation_units: maker.toString(),
    trading_base_units: (pool - maker).toString(),
  };
}
